var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHealthAndFitness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Smart-Watch-Square-Graph-Line--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Smart Watch Square Graph Line Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.43 2.75a0.25 0.25 0 0 0 0.2 -0.1 0.27 0.27 0 0 0 0 -0.23L16 0.34a0.5 0.5 0 0 0 -0.5 -0.34h-7a0.5 0.5 0 0 0 -0.5 0.34l-0.7 2.08a0.27 0.27 0 0 0 0 0.23 0.25 0.25 0 0 0 0.2 0.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57 21.25a0.25 0.25 0 0 0 -0.2 0.1 0.27 0.27 0 0 0 0 0.23L8 23.66a0.5 0.5 0 0 0 0.5 0.34h7a0.5 0.5 0 0 0 0.47 -0.34l0.7 -2.08a0.27 0.27 0 0 0 0 -0.23 0.25 0.25 0 0 0 -0.2 -0.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.07 12.25 2.27 -3.9a1.28 1.28 0 0 1 1.18 -0.6 1.26 1.26 0 0 1 1 0.76l1.79 5.16a0.25 0.25 0 0 0 0.47 0L13.9 11a1.25 1.25 0 0 1 1.1 -0.71 1.21 1.21 0 0 1 1.12 0.61l0.81 1.35h2.83A0.25 0.25 0 0 0 20 12V6.5A2.5 2.5 0 0 0 17.5 4h-11A2.5 2.5 0 0 0 4 6.5V12a0.25 0.25 0 0 0 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.75a0.75 0.75 0 0 1 -0.64 -0.36l-0.52 -0.87a0.25 0.25 0 0 0 -0.24 -0.12 0.27 0.27 0 0 0 -0.21 0.15l-1.21 3a1.28 1.28 0 0 1 -1.15 0.74 1.23 1.23 0 0 1 -1.11 -0.76l-1.9 -5.42a0.24 0.24 0 0 0 -0.21 -0.11 0.25 0.25 0 0 0 -0.24 0.12l-1.92 3.26a0.76 0.76 0 0 1 -0.65 0.37H4.25A0.25 0.25 0 0 0 4 14v3.5A2.51 2.51 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5 -2.5V14a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHealthAndFitness);
export default ForwardRef;